"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordStrength = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _zxcvbn = _interopRequireDefault(require("zxcvbn"));
var _lodash = require("lodash");
var _hooks = require("../../hooks");
var _style = require("./style");
var _utils = require("./utils");
var _utils2 = require("../../../build/components/PasswordStrength/utils");
var _uuid = require("../../utils/uuid");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getWeakPasswordScoreMessage = (password, intl) => {
  const suggestions = [];
  if (password.length < _utils2.MIN_PASSWORD_LENGTH) {
    suggestions.push(intl.formatMessage({
      id: 'password_score_message_min_length'
    }, {
      minLength: _utils2.MIN_PASSWORD_LENGTH
    }));
  }
  if (!/[a-z]/.test(password)) {
    suggestions.push(intl.formatMessage({
      id: 'password_score_message_require_lowercase'
    }));
  }
  if (!/[A-Z]/.test(password)) {
    suggestions.push(intl.formatMessage({
      id: 'password_score_message_require_uppercase'
    }));
  }
  if (!/\d/.test(password)) {
    suggestions.push(intl.formatMessage({
      id: 'password_score_message_require_digit'
    }));
  }
  const formattedSuggestions = suggestions.length > 1 ? intl.formatMessage({
    id: 'password_score_message_and'
  }, {
    multipleSuggestions: suggestions.slice(0, -1).join(', '),
    singleSuggestion: suggestions[suggestions.length - 1]
  }) : suggestions[0];
  return suggestions.length > 0 ? intl.formatMessage({
    id: 'password_score_message_base'
  }, {
    suggestions: formattedSuggestions
  }) : null;
};
const PasswordStrength = _ref => {
  let {
    password = '',
    onStrengthChange = _lodash.noop
  } = _ref;
  const {
    locale
  } = (0, _hooks.useConfig)();
  const classes = (0, _style.useStyles)();
  const intl = (0, _hooks.useIntl)();
  const [strength, setStrengthState] = (0, _react.useState)(_utils.STRENGTH.NONE);
  const [message, setMessage] = (0, _react.useState)('');
  const strengthBarsCount = _utils.STRENGTH_BARS_COUNT[strength];
  const setStrength = value => {
    onStrengthChange(value);
    setStrengthState(value);
  };
  (0, _react.useEffect)(() => {
    if (password.length === 0) {
      setStrength(_utils.STRENGTH.NONE);
      setMessage(intl.formatMessage({
        id: 'password_strength_requirements'
      }, {
        minLength: _utils2.MIN_PASSWORD_LENGTH
      }));
      return;
    }
    const weakPasswordMessage = getWeakPasswordScoreMessage(password, intl);
    if (weakPasswordMessage) {
      setStrength(_utils.STRENGTH.WEAK);
      setMessage(weakPasswordMessage);
      return;
    }
    const {
      score
    } = (0, _zxcvbn.default)(password);
    const newStrength = _utils.SCORE_STRENGTH[score];
    setStrength(_utils.SCORE_STRENGTH[score]);
    setMessage(intl.formatMessage({
      id: _utils.STRENGTH_MESSAGE[newStrength]
    }));
  }, [password, locale]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    gridGap: 6
  }, Array.from({
    length: strengthBarsCount
  }).map(() => /*#__PURE__*/_react.default.createElement("div", {
    key: (0, _uuid.getUid)(),
    className: (0, _clsx.default)(classes.bar, classes[`bar-${strength}`])
  })), Array.from({
    length: _utils.BARS_COUNT - strengthBarsCount
  }).map(() => /*#__PURE__*/_react.default.createElement("div", {
    key: (0, _uuid.getUid)(),
    className: (0, _clsx.default)(classes.bar, classes[`bar-${_utils.STRENGTH.NONE}`])
  }))), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "body2",
    component: "p",
    className: classes[`text-${strength}`]
  }, message));
};
exports.PasswordStrength = PasswordStrength;